import { useUserInfos } from './useUserInfos';

export const useUsers = () => {
  const { userInfos } = useUserInfos();

  const users =
    userInfos?.UserList?.map(user => ({
      id: user.Id,
      email: user.Email,
      firstName: user.FirstName,
      lastName: user.LastName,
    })) || [];

  return { users };
};
